/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiLeadStatusRuleConditionPayloadFromJSON, ApiLeadStatusRuleConditionPayloadToJSON, } from './ApiLeadStatusRuleConditionPayload';
export function ApiLeadStatusRuleConditionGroupPayloadFromJSON(json) {
    return ApiLeadStatusRuleConditionGroupPayloadFromJSONTyped(json, false);
}
export function ApiLeadStatusRuleConditionGroupPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'conditions': !exists(json, 'conditions') ? undefined : (json['conditions'].map(ApiLeadStatusRuleConditionPayloadFromJSON)),
    };
}
export function ApiLeadStatusRuleConditionGroupPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'conditions': value.conditions === undefined ? undefined : (value.conditions.map(ApiLeadStatusRuleConditionPayloadToJSON)),
    };
}
